module.exports = __webpack_public_path__ + "static/media/izlozba (14).c93de516.jpg";